export const toTranslationKey = (key: string) => key as never;

export const toNamespaceKey = (key: string) => key as never;

export const tForComponent =
	(t: (k: never, ...args: never[]) => string) =>
	(key: string, ...args: unknown[]) =>
		(t as (k: string, ...a: unknown[]) => string)(key, ...args);
